import { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { EnquiryProvider } from "@/components/Enquiry";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingContact from "@/components/FloatingContact";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import DestinationPage from "@/pages/DestinationPage";
import CharDham from "@/pages/CharDham";
import Itineraries from "@/pages/Itineraries";
import Admin from "@/pages/Admin";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-ink p-8 text-center">
          <p className="font-display text-2xl text-gold">Something went wrong</p>
          <button onClick={() => window.location.reload()} className="btn-gold">Reload Page</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const RouteEffects = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 350);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const LenisSetup = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
  return null;
};

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <LenisSetup />
        <RouteEffects />
        <EnquiryProvider>
          <Navbar />
          <main className="min-h-screen">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/explore" element={<Explore />} />
              <Route path="/destination/:slug" element={<DestinationPage />} />
              <Route path="/char-dham" element={<CharDham />} />
              <Route path="/weekend-trips" element={<Itineraries />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <FloatingContact />
        </EnquiryProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
